export default class clientType {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        clientTypeRetrieve(id: ${id}) {
          id
          name
          desc
          logo {
            id 
            url
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.clientTypeRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        clientTypeList {
          results {
            id
            name
            desc
            logo {
              id
              url
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.clientTypeList.results.reverse();
  }

  // static async filter(axios, region) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       cityList (region: ${region}){
  //         results {
  //           id
  //           name
  //           latitude
  //           longitude
  //           region {
  //             id
  //             name
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //   return response.data.data.cityList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteClientType(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteClientType.ok;
  }

  static async create(axios, name, desc, logo) {
    const description = desc !== null ? `desc: "${desc}"`: ``;
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;
    
    const response = await axios.post(
      '/graphql/',
      `mutation{
        createClientType(newClienttype: {
          ${logoField}
          name: "${name}", 
          ${description}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createClientType.ok;
  }


  static async edit(axios, id, name, desc, logo) {
    const description = desc !== null ? `desc: "${desc}"`: ``;
    const logoField = (logo !== -1) ? `logo: ${logo},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateClientType(newClienttype: {
          ${logoField}
          id: ${id},
          name: "${name}", 
          ${description}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateClientType.ok;
  }

}